import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "18",
  viewBox: "0 0 22 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M1 6V2C1 1.45 1.196 0.979333 1.588 0.588C1.98 0.196667 2.45067 0.000666667 3 0H19C19.55 0 20.021 0.196 20.413 0.588C20.805 0.98 21.0007 1.45067 21 2V6H19V2H3V6H1ZM3 15C2.45 15 1.97933 14.8043 1.588 14.413C1.19667 14.0217 1.00067 13.5507 1 13V8H3V13H19V8H21V13C21 13.55 20.8043 14.021 20.413 14.413C20.0217 14.805 19.5507 15.0007 19 15H3ZM0 18V16H22V18H0ZM1 8V6H7C7.18333 6 7.35833 6.05 7.525 6.15C7.69167 6.25 7.81667 6.38333 7.9 6.55L9.075 8.875L12.15 3.5C12.2333 3.35 12.35 3.229 12.5 3.137C12.65 3.045 12.8167 2.99933 13 3C13.1833 3.00067 13.3583 3.04667 13.525 3.138C13.6917 3.22933 13.8167 3.36667 13.9 3.55L15.125 6H21V8H14.5C14.3167 8 14.1417 7.95433 13.975 7.863C13.8083 7.77167 13.6833 7.634 13.6 7.45L12.95 6.125L9.875 11.5C9.79167 11.6667 9.66667 11.7917 9.5 11.875C9.33333 11.9583 9.15833 12 8.975 12C8.79167 12 8.62067 11.95 8.462 11.85C8.30333 11.75 8.18267 11.6167 8.1 11.45L6.375 8H1Z",
        fill: "currentColor"
      })
    ], -1)
  ]))]))
}
export default { render: render }